import ISignatureCobranca from "./ISignatureCobranca"
import ISignaturePagamento, { instanceOfISignaturePagamento } from "./ISignaturePagamento"
import ISignatureResponsavel, { instanceOfISignatureResponsavel } from "./ISignatureResponsavel"
import Nullable from "./utils/Nullable"

interface IPedido{
    recaptcha: string,
    canal_venda: string,
    tipo_oferta: string,
    oferta: string,
    empresa_prestadora?: number,
    recebedor_comissao?: number,
    tipo_publicidade: string,
    tipo_aquisicao?: string,
    dias_inicio?: number,
    dias_termino?: number,
    url?: Nullable<string>,
    referrer_url?: Nullable<string>,
    skip?: boolean,
    responsavel: ISignatureResponsavel,
    recebedor?: ISignatureResponsavel,
    cobranca?: ISignatureCobranca,
    entrega?: ISignatureCobranca,
    pagamento: ISignaturePagamento
}

export const instanceOfIPedido = (object: any) : object is IPedido => {
    return 'recaptcha' in object &&
            'canal_venda' in object &&
            'tipo_oferta' in object &&
            'oferta' in object &&
            'tipo_publicidade' in object &&
            'responsavel' in object &&
            'pagamento' in object &&
            instanceOfISignatureResponsavel(object.responsavel) &&
            instanceOfISignaturePagamento(object.pagamento)
}

export default IPedido